if (!customElements.get('wlsn-product-tabs')) {
  class WLSNProductTabs extends HTMLElement {
    constructor() {
      super();

      this.classes = {
        tabContentButton: 'js-product-tab-content-button',
        tabContentContainer: 'js-tab-content-container',
        navTabsInner: 'js-wlsn-nav-tabs-inner',
        active: 'active',
        hidden: 'hidden',
      }

      this.bindMethods = {
        onTabClick: this._onTabClick.bind(this),
      }
    }

    get elements() {
      return {
        navTabsInner: this.querySelector(`.${this.classes.navTabsInner}`),
        tabContentContainer: this.querySelector(`.${this.classes.tabContentContainer}`),
      }
    }

    connectedCallback() {
      this._setupTabs();
      this._activateFirstTab();
    }

    disconnectedCallback() {
      this._removeEventListeners();
    }

    _setupTabs() {
      const { navTabsInner } = this.elements;
      if (!navTabsInner) return;

      const tabContentButtons = navTabsInner.querySelectorAll(`.${this.classes.tabContentButton}`);
      if (!tabContentButtons || tabContentButtons.length === 0) return;

      tabContentButtons.forEach((button) => {
        button.addEventListener('click', this.bindMethods.onTabClick);
      });
    }

    _removeEventListeners() {
      const { navTabsInner } = this.elements;
      if (!navTabsInner) return;

      const tabContentButtons = navTabsInner.querySelectorAll(`.${this.classes.tabContentButton}`);
      if (!tabContentButtons || tabContentButtons.length === 0) return;

      tabContentButtons.forEach((button) => {
        button.removeEventListener('click', this.bindMethods.onTabClick);
      });
    }

    _onTabClick(e) {
      const button = e.currentTarget;
      const tabId = button.getAttribute('data-tab-id');
      
      if (!tabId) return;

      this._switchTab(tabId);
    }

    _switchTab(tabId) {
      const { navTabsInner, tabContentContainer } = this.elements;
      if (!tabContentContainer || !navTabsInner) return;

      const tabContentButtons = navTabsInner.querySelectorAll(`.${this.classes.tabContentButton}`);

      tabContentButtons.forEach((btn) => {
        btn.classList.remove(this.classes.active);
      });

      const allContent = tabContentContainer.querySelectorAll('[data-tab-id]');
      allContent.forEach((content) => {
        content.classList.add(this.classes.hidden);
      });

      const activeButton = Array.from(tabContentButtons).find(
        (btn) => btn.getAttribute('data-tab-id') === tabId
      );
      if (activeButton) {
        activeButton.classList.add(this.classes.active);
      }

      const activeContent = tabContentContainer.querySelector(`[data-tab-id="${tabId}"]`);
      if (activeContent) {
        activeContent.classList.remove(this.classes.hidden);
      }
    }

    _activateFirstTab() {
      const { navTabsInner } = this.elements;
      if (!navTabsInner) return;

      const tabContentButtons = navTabsInner.querySelectorAll(`.${this.classes.tabContentButton}`);
      if (!tabContentButtons || tabContentButtons.length === 0) return;

      const firstTabId = tabContentButtons[0].getAttribute('data-tab-id');
      if (firstTabId) {
        this._switchTab(firstTabId);
      }
    }
  }
  customElements.define('wlsn-product-tabs', WLSNProductTabs);
}